import styled from "styled-components";
import { media } from "@/theme/breakpoints";

export const MainContainer = styled.div`
  background: #2a2a2a;
  width: 100%;
  overflow-x: hidden;
`;

export const InnerContainer = styled.div`
  text-align: center;
  padding: 12px 40px;
  box-sizing: border-box;

  ${media.downTablet`
    padding: 12px 24px;
  `}

  ${media.downMobile`
    padding: 12px 16px;
  `}
`;

export const StyledHeading = styled.h4`
  margin: 0;
  color: #fff;
  font-family: Inter;
  font-size: 15.625px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  overflow-wrap: anywhere;

  ${media.downMobile`
    font-size: 14px;
    line-height: 20px;
  `}
`;
